import { useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { useEffect } from 'react'
import { useToast } from '@/components/ui'
import { configsService } from '@/services/http/configsService'

export const useTermsOfUse = () => {
  const { toast } = useToast()

  const {
    data: termsOfUse,
    isError,
    error,
    isLoading,
    refetch: refetchTermsOfUse,
  } = useQuery({
    queryKey: ['termsOfUse'],
    queryFn: () => configsService.getTermsOfUse(),
  })

  useEffect(() => {
    if (isError) {
      const axiosError = error as AxiosError<{ message: string }>
      const title =
        axiosError?.response?.data?.message || 'Erro ao buscar termos de uso'

      toast({
        title,
        variant: 'destructive',
      })
    }
  }, [error, isError, toast])

  return {
    termsOfUse,
    isLoading,
    refetchTermsOfUse,
  }
}
